import { decodeBase64 } from '@vista-digital/utilities';
/**
 * Decodes and parses a JWT auth token and returns it's payload.
 */
export const parseAuthToken = (token) => {
    let parsedToken;
    try {
        const tokenPayload = token.split('.')[1];
        const decodedToken = decodeBase64(tokenPayload);
        parsedToken = JSON.parse(decodedToken);
    }
    catch (_a) {
        throw new Error('Failed to decode and parse auth token.');
    }
    return parsedToken;
};
/**
 * Gets the workstationId from a parsed JWT auth token.
 */
export const getWorkstationIdFromParsedToken = (parsedToken) => {
    var _a;
    return (_a = parsedToken['https://devices.vista.co/workstationId']) !== null && _a !== void 0 ? _a : undefined;
};
/**
 * Parses a JWT auth token and returns its user ID (sub) property.
 */
export const getUserIdFromAuthToken = (token) => {
    const parsedToken = parseAuthToken(token);
    return getUserIdFromParsedToken(parsedToken);
};
/**
 * Gets the sub property from a parsed JWT auth token.
 */
export const getUserIdFromParsedToken = (parsedToken) => {
    if (parsedToken.sub) {
        return parsedToken.sub;
    }
    throw new Error('Cannot find user ID (sub) property from auth token.');
};
/**
 * Gets the productCode from a parsed JWT auth token.
 */
export const getProductCodeFromParsedToken = (parsedToken) => {
    var _a;
    return (_a = parsedToken['https://devices.vista.co/productCode']) !== null && _a !== void 0 ? _a : undefined;
};
//# sourceMappingURL=auth-token-utils.js.map